let csrfToken: string | null = null

export class ApiClientError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly details?: unknown,
  ) {
    super(message)
  }
}

export function setCsrfToken(value: string | null) {
  csrfToken = value
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`/api/v1${path}`, {
    ...init,
    credentials: 'same-origin',
    headers: {
      ...(init.body ? { 'content-type': 'application/json' } : {}),
      ...(csrfToken && init.method && !['GET', 'HEAD'].includes(init.method)
        ? { 'x-csrf-token': csrfToken }
        : {}),
      ...init.headers,
    },
  })
  if (!response.ok) {
    const value = (await response.json().catch(() => null)) as {
      error?: { code?: string; message?: string; details?: unknown }
    } | null
    throw new ApiClientError(
      response.status,
      value?.error?.code ?? 'request_failed',
      value?.error?.message ?? 'The request could not be completed',
      value?.error?.details,
    )
  }
  if (response.status === 204) return undefined as T
  return (await response.json()) as T
}

export function jsonBody(value: unknown): Pick<RequestInit, 'body'> {
  return { body: JSON.stringify(value) }
}

export async function finderApi<T>(bottleId: string, token: string, path: string, body: unknown) {
  return api<T>(`/bottles/${bottleId}${path}`, {
    method: 'POST',
    headers: { authorization: `Finder ${token}` },
    ...jsonBody(body),
  })
}
